

export default {
  id: "power_meter_type_id",
  key: "cp_power_meter",
  fields: [
    { key: "name" },
    { key: "factor" },
    { key: "rotation_value" },
    { type: "action-btn" }
  ],
  action: ["create","edit"],
  page_setting: { min: 10, max: 100, step: 10, }
  // page_setting: [10,20,50,100]
}